// src/components/Home.js
import React from 'react';
import Styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

function Product() {
  const { t } = useTranslation();

  const imageFiles = [
    { img: 'Buffalo.jpg', title: t("Full Cream Milk"), sizes: " 500ml, 1000ml" },
    { img: 'ghee.png', title: t("Ghee"), sizes: "100ml,200ml, 500ml, 1000ml" },
    { img: 'cowmilk.png', title: t("Cow Milk"), sizes: "200ml, 500ml, 1000ml" },
    { img: 'curd.png', title: t("Curd"), sizes: "200ml, 500ml, 1KG,2KG" },
    { img: 'taza milk.png', title: t("Taza Milk"), sizes: "200ml, 500ml, 1000ml" },
    { img: 'buttermilk.png', title: t("Butter Milk"), sizes: "500ml" },
    { img: 'lassi.png', title: t("Lassi"), sizes: "200 ml" },
    { img: 'paneer.png', title: t("Paneer"), sizes: "500g, 1kg, 2kg" }
  ];

  return (
    <div className={Styles.appContainer}>
      <section className={Styles.pageSection}>
        <h1 className={Styles.pageHeader}>{t('Our Products')}</h1>
        <p className={Styles.pageIntro}>
          {t('Discover our range of fresh dairy essentials crafted with love and care. Every product is made with purity and quality in mind.')}
        </p>
        <div className={Styles.imagegrid}>
          {imageFiles.map((imageFile, index) => (
            <div key={index} className={Styles.productCard}>
              <img
                src={require(`../asset/Image/${imageFile.img}`)}
                alt={`Krushiratna ${imageFile.title}`}
              />
              <p className={Styles.imageText}>{imageFile.title}</p>
              <p className={Styles.sizeText}>{imageFile.sizes}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Product;
